<mat-card
  *ngIf="showHoverCard && title"
  class="hovercard"
>
  <div class="info full-width">
    <div class="title overflow-ellipsis full-width">{{title}}</div>
    <div class="subtitle overflow-ellipsis full-width">{{subtitle}}</div>
  </div>
</mat-card>
